import axios, { AxiosResponse } from 'axios';
import authHeader from '@/services/auth-header';
import Page from '@/dto/taxation/Page';
import SublimeChargeDTO, { ChargeComponent } from '@/dto/subscription/SublimeChargeDTO';
import { SUBSCRIPTIONS_CHARGES_ENDPOINT, SUBSCRIPTIONS_PLANS_ENDPOINT, SUBSCRIPTIONS_ACTIVE_COMPONENT_ENDPOINT } from '@/constants/endpoints';
import ActivePlanComponentDTO from '@/dto/employment/ActivePlanComponentDTO';

import SubscriptionPlanDTO from '@/dto/subscription/SubscriptionPlanDTO';

export default new class SubscriptionService {
  public getCharges(pageNumber: number, pageSize: number, companyId?: number, issuerAbbreviation?: string): Promise<AxiosResponse<Page<SublimeChargeDTO>>> {
    const params: Record<string, any> = {
      pageNumber,
      pageSize,
    };
    if (companyId !== undefined && companyId !== null) params.companyId = companyId;
    if (issuerAbbreviation) params.issuer = issuerAbbreviation;

    const query = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') query.append(k, String(v));
    });

    return axios.get<Page<SublimeChargeDTO>>(`${SUBSCRIPTIONS_CHARGES_ENDPOINT}?${query.toString()}`, { headers: authHeader() });
  }

  public getPlans(pageNumber: number, pageSize: number): Promise<AxiosResponse<Page<SubscriptionPlanDTO>>> {
    const params: Record<string, any> = { pageNumber, pageSize };
    const query = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') query.append(k, String(v));
    });
    return axios.get<Page<SubscriptionPlanDTO>>(`${SUBSCRIPTIONS_PLANS_ENDPOINT}?${query.toString()}` , { headers: authHeader() });
  }

  public getActiveComponent(companyId: number, component: ChargeComponent): Promise<AxiosResponse<ActivePlanComponentDTO | null>> {
    const params: Record<string, any> = { companyId, component };
    const query = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') query.append(k, String(v));
    });
    return axios.get<ActivePlanComponentDTO | null>(`${SUBSCRIPTIONS_ACTIVE_COMPONENT_ENDPOINT}?${query.toString()}`, { headers: authHeader() });
  }
}